"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90526],{

/***/ 628054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(431529);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(693701);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(622746);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SubTitle13 = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK)``;
const BasePage = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  z-index: 1;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const InteractPage = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(BasePage)(({ theme, active, disabled, color }) => `
border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
background-color: ${active ? (theme == null ? void 0 : theme.colors[color]) || color : theme == null ? void 0 : theme.colors.white};
border: ${active ? "none" : `1px solid ${theme == null ? void 0 : theme.colors.divider}`};
pointer-events: ${disabled ? "none" : "auto"};
${!active ? `
  cursor: pointer;
  &:hover {
    path[stroke],
    rect[stroke],
    line {
      stroke: ${theme == null ? void 0 : theme.colors.white};
    }
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${theme == null ? void 0 : theme.colors.white};
    }
    ${SubTitle13} {
      color: ${theme == null ? void 0 : theme.colors.white};
    }
    background-color: ${theme == null ? void 0 : theme.colors.background};
  }` : `
  ${SubTitle13} {
    color: ${theme == null ? void 0 : theme.colors.white};
  }
`}
`);
const PaginationWrap = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: inline-flex;
  > *:not(:first-child) {
    margin-left: ${({ theme }) => theme == null ? void 0 : theme.spacing.s8};
  }
`;
const StyledPagination = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F};
  width: 100%;
  text-align: ${(p) => p.align};
`;
const range = (from, to) => {
  return Array.from({ length: to - from + 1 }, (v, k) => k + from);
};
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const generatePageNumbers = (totalPages, currentPage, pageNeighbor) => {
  const totalNumbers = pageNeighbor * 2 + 3;
  const totalBlocks = totalNumbers + 2;
  if (totalPages > totalBlocks) {
    let pages = [];
    const curr = currentPage > totalPages ? totalPages : currentPage;
    const leftBound = curr - pageNeighbor;
    const rightBound = curr + pageNeighbor;
    const beforeLastPage = totalPages - 1;
    const startPage = leftBound > 2 ? leftBound : 2;
    const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
    pages = range(startPage, endPage);
    const pagesCount = pages.length;
    const singleSpillOffset = totalNumbers - pagesCount - 1;
    const leftSpill = startPage > 2;
    const rightSpill = endPage < beforeLastPage;
    const leftSpillPage = LEFT_PAGE;
    const rightSpillPage = RIGHT_PAGE;
    if (leftSpill && !rightSpill) {
      const extraPages = range(startPage - singleSpillOffset, startPage - 1);
      pages = [leftSpillPage, ...extraPages, ...pages];
    } else if (!leftSpill && rightSpill) {
      const extraPages = range(endPage + 1, endPage + singleSpillOffset);
      pages = [...pages, ...extraPages, rightSpillPage];
    } else if (leftSpill && rightSpill) {
      pages = [leftSpillPage, ...pages, rightSpillPage];
    }
    return [1, ...pages, totalPages];
  }
  return range(1, totalPages);
};
const Pagination = (_a) => {
  var _b = _a, {
    totalRecords,
    currentPage,
    pageLimit = 30,
    pageNeighbor = 2,
    onPageChange,
    align = "center",
    color = "primary500",
    itemRender
  } = _b, rest = __objRest(_b, [
    "totalRecords",
    "currentPage",
    "pageLimit",
    "pageNeighbor",
    "onPageChange",
    "align",
    "color",
    "itemRender"
  ]);
  var _a2;
  const totalPages = Math.ceil(totalRecords / pageLimit);
  const gotoPage = (page) => {
    onPageChange == null ? void 0 : onPageChange(page);
  };
  const onBackward = () => {
    gotoPage(currentPage - 1);
  };
  const onForward = () => {
    gotoPage(currentPage + 1);
  };
  const pages = generatePageNumbers(totalPages, currentPage, pageNeighbor);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPagination, __spreadValues({
    align
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationWrap, null, (itemRender == null ? void 0 : itemRender["pre"]) ? (_a2 = itemRender["pre"]) == null ? void 0 : _a2.call(itemRender, currentPage - 1, {
    color,
    disabled: currentPage === 1
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InteractPage, __spreadValues({
    color,
    disabled: currentPage === 1,
    onClick: onBackward
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "previousPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .BackOutlined */ .Y, {
    size: 16,
    color: "placeholder"
  })), pages.map((page, index) => {
    var _a3;
    if ([LEFT_PAGE, RIGHT_PAGE].includes(page.toString())) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BasePage, {
        key: index
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .DotOutlined */ .h, {
        size: 16,
        color: "border"
      }));
    }
    const isActive = page === currentPage;
    return (itemRender == null ? void 0 : itemRender["page"]) ? (_a3 = itemRender["page"]) == null ? void 0 : _a3.call(itemRender, page, {
      color,
      active: isActive
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InteractPage, __spreadValues({
      color,
      active: isActive,
      key: index,
      onClick: isActive ? void 0 : () => onPageChange == null ? void 0 : onPageChange(typeof page === "string" ? parseInt(page) : page)
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName: "paging",
      contentName: "gotoPage",
      target: `${page}`
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SubTitle13, {
      level: 4,
      color: isActive ? "white" : "textPrimary"
    }, page));
  }), (itemRender == null ? void 0 : itemRender["next"]) ? itemRender["next"](currentPage + 1, {
    color,
    disabled: currentPage === 1
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InteractPage, __spreadValues({
    color,
    disabled: currentPage === totalPages,
    onClick: onForward
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "nextPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .ForwardOutlined */ .d, {
    size: 16,
    color: "placeholder"
  }))));
};




/***/ }),

/***/ 603626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ InputSlider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285212);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputSlider = (_a) => {
  var _b = _a, {
    range,
    min = 0,
    max = 100,
    value,
    defaultValue,
    onChange,
    disabled,
    step = 1,
    ref,
    tipFormatter,
    size = _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m,
    color = "primary",
    tooltip = true,
    changeOn = "dragging"
  } = _b, props = __objRest(_b, [
    "range",
    "min",
    "max",
    "value",
    "defaultValue",
    "onChange",
    "disabled",
    "step",
    "ref",
    "tipFormatter",
    "size",
    "color",
    "tooltip",
    "changeOn"
  ]);
  var _a2, _b2, _c;
  const valueDefault = defaultValue ? defaultValue : range ? [min, max] : min;
  const valueSlider = value !== void 0 ? value : valueDefault;
  const innerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const trackFillRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([null, null]);
  const thumbRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([null, null]);
  const mouseMoveEventRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const mouseUpEventRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const percents = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(getPercent(max, min, valueSlider));
  const currentPercent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const isDragging = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const formatter = (value2) => {
    if (value2 === void 0)
      return "";
    if (tipFormatter)
      return tipFormatter(value2);
    return new Intl.NumberFormat("en-CA", {
      maximumFractionDigits: 10
    }).format(value2);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    document.removeEventListener("mousemove", mouseMoveEventRef.current || (() => {
    }));
    document.removeEventListener("mouseup", mouseUpEventRef.current || (() => {
    }));
    document.removeEventListener("touchmove", mouseMoveEventRef.current || (() => {
    }));
    document.removeEventListener("touchend", mouseUpEventRef.current || (() => {
    }));
  }, []);
  const clickInTrack = (e) => {
    var _a3;
    e.stopPropagation();
    const { pageX } = getPosition(e);
    const { left = 0, width } = ((_a3 = innerRef.current) == null ? void 0 : _a3.getBoundingClientRect()) || {};
    if (!width) {
      return;
    }
    const newValue = (Number(pageX || left) - left) / width * 100;
    const [currentLeft, currentRight] = percents.current;
    const [deltaLeft, deltaRight] = [
      newValue - currentLeft,
      currentRight - newValue
    ];
    const activeIndex = range && deltaLeft < deltaRight ? 0 : 1;
    setPositions(pageX, activeIndex);
    setTooltipVisible(activeIndex, "visible");
    changeValue();
  };
  const onStartMove = (e, index) => {
    e.stopPropagation();
    currentPercent.current = percents.current[index];
    const onMouseMove = (event) => {
      isDragging.current = true;
      const { pageX: moveX } = getPosition(event);
      setPositions(moveX, index);
    };
    const onMouseUp = () => {
      setTooltipVisible(index, "hidden");
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("touchend", onMouseUp);
      document.removeEventListener("touchmove", onMouseMove);
      changeOn === "dragend" && changeValue();
      mouseMoveEventRef.current = null;
      mouseUpEventRef.current = null;
      isDragging.current = false;
      currentPercent.current = null;
    };
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("touchend", onMouseUp);
    document.addEventListener("touchmove", onMouseMove);
    mouseMoveEventRef.current = onMouseMove;
    mouseUpEventRef.current = onMouseUp;
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (percents.current === void 0 || valueSlider === void 0)
      return;
    const [leftPercent, rightPercent] = getPercent(max, min, valueSlider);
    if (percents.current[0] === leftPercent && percents.current[1] === rightPercent) {
      return;
    }
    percents.current = [leftPercent, rightPercent];
    determinePosition(rightPercent - leftPercent, leftPercent);
  }, [valueSlider.toString(), max, min, range]);
  const getValue = (percent) => {
    const value2 = percent * (max - min) / 100;
    const v = Math.round(value2 / step) * step;
    const displayValue = Math.round(v * 100) / 100 + min;
    return displayValue > max ? max : displayValue;
  };
  const setPositions = (pageX = 0, index = null) => {
    var _a3;
    const { left = 0, width } = ((_a3 = innerRef.current) == null ? void 0 : _a3.getBoundingClientRect()) || {};
    if (!width) {
      return;
    }
    const newValue = (Number(pageX || left) - left) / width * 100;
    changePercent(newValue, index);
    changeOn === "dragging" && changeValue();
  };
  const determinePosition = (percent, leftPercent) => {
    if (trackFillRef.current) {
      trackFillRef.current.style.width = `${percent}%`;
      trackFillRef.current.style.left = `${leftPercent}%`;
    }
    if (thumbRefs.current && tooltipRefs.current) {
      percents.current.forEach((pos, index) => {
        if (thumbRefs.current[index]) {
          thumbRefs.current[index].style.left = `calc(${pos}% ${pos === 100 ? `- ${sizes[size].thumb / 2}px` : ""})`;
        }
        if (tooltipRefs.current[index]) {
          tooltipRefs.current[index].innerText = formatter(getValue(pos));
        }
      });
    }
  };
  const changeValue = () => {
    const [_left, _right] = percents.current;
    const newValues = [getValue(_left), getValue(_right)];
    if (newValues.toString() === valueSlider.toString())
      return;
    onChange == null ? void 0 : onChange(range ? newValues : newValues[1]);
  };
  const changePercent = (value2, index = null) => {
    let newValue = value2;
    const ltr = newValue - (currentPercent.current || 0) > 0;
    if (percents.current) {
      let [thumbLeft, thumbRight] = percents.current;
      if (ltr && getValue(newValue) > getValue(thumbRight) && index === 0) {
        return;
      }
      if (!ltr && getValue(newValue) < getValue(thumbLeft) && index === 1) {
        return;
      }
      if (newValue >= 100) {
        newValue = 100;
      }
      if (newValue <= 0) {
        newValue = 0;
      }
      if (index === null) {
        const middle = (thumbLeft + thumbRight) / 2;
        currentPercent.current = newValue;
        if (newValue > middle || !range) {
          thumbRight = newValue;
        } else {
          thumbLeft = newValue;
        }
        percents.current = [thumbLeft, thumbRight];
      } else {
        percents.current[index] = newValue;
      }
      const [_left, _right] = percents.current;
      const percent = _right - _left;
      determinePosition(percent, _left);
    }
  };
  const setTooltipVisible = (index, value2) => {
    if (tooltipRefs.current[index])
      tooltipRefs.current[index].style.visibility = value2;
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderWrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref: innerRef,
    size,
    color,
    onMouseDown: clickInTrack
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderTrack, {
    className: "slider-track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SliderTrackFill, {
    className: "slider-track-fill",
    ref: trackFillRef,
    style: {
      width: `${((_a2 = percents.current) == null ? void 0 : _a2[1]) - ((_b2 = percents.current) == null ? void 0 : _b2[0])}%`,
      left: `${(_c = percents.current) == null ? void 0 : _c[0]}%`
    }
  })), [...Array(2)].map((_, index) => {
    var _a3;
    return !range && index == 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StylerThumb, {
      key: index,
      className: "slider-thumb",
      ref: (e) => {
        thumbRefs.current[index] = e;
      },
      style: {
        left: `${(_a3 = percents.current) == null ? void 0 : _a3[index]}%`
      },
      onMouseDown: (e) => onStartMove(e, index),
      onTouchStart: (e) => onStartMove(e, index),
      onMouseMove: () => !isDragging.current && setTooltipVisible(index, "visible"),
      onTouchMove: () => !isDragging.current && setTooltipVisible(index, "visible"),
      onMouseOut: () => !isDragging.current && setTooltipVisible(index, "hidden"),
      onTouchCancel: () => !isDragging.current && setTooltipVisible(index, "hidden"),
      role: "slider"
    }, tooltip && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyleTooltip, {
      className: "tooltip",
      ref: (e) => tooltipRefs.current[index] = e
    }, formatter(getValue(percents.current[index]))));
  })));
};
InputSlider.displayName = "InputSlider";
const SliderWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F};
  padding: 0.5rem 0;
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme, size, color }) => `
  position: relative;
  height: ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].height}px;
  width: 100%;

  & >.slider-track .slider-track-fill {
     background-color: ${theme.colors[color] || color};
  }

  & >.slider-thumb{
    box-shadow: 0px 0px 0px 1.5px ${theme.colors[color] || color} inset;
    width: ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].thumb}px;
    height:  ${sizes[size || _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m].thumb}px;
  }
`);
const SliderTrack = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
`;
const SliderTrackFill = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: absolute;
  top: 0;
  height: 100%;
`;
const StylerThumb = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme }) => `
  position: absolute;
  border-radius: 1000px;
  top: 0;
  transform: translate(-25%, -50%);
  background-color: ${theme.colors.white};
  text-align: center;
  cursor: pointer;
  top: 50%
`);
const StyleTooltip = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].span(({ theme }) => `
  visibility: hidden;
  background-color: ${theme.colors.black};
  color: #fff;
  text-align: center;
  padding: 2px 3px;
  position: absolute;
  z-index: 1;
  font-size: 0.625rem;
  border-radius: 3px;
  transform: translate(-50%, -150%);
  min-width: 1.25rem;
  user-select: none;
  // arrow
  &:after {
    content: '';
    width: 8px;
    height: 5px;
    bottom: -5px;
    border-top: 4px solid ${theme.colors.black};
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }
`);
const sizes = {
  xs: {
    height: 3,
    thumb: 9
  },
  s: {
    height: 4,
    thumb: 11
  },
  m: { height: 5, thumb: 12 },
  l: { height: 7, thumb: 15 },
  xl: { height: 4, thumb: 20 }
};
function getPosition(e) {
  const obj = "touches" in e ? e.touches[0] : e;
  return { pageX: obj.pageX, pageY: obj.pageY };
}
const getPercent = (max, min, valueSlider) => {
  let leftValue = min, rightValue = max;
  if (typeof valueSlider === "number") {
    rightValue = valueSlider;
  } else {
    [leftValue, rightValue] = valueSlider;
  }
  let [leftPercent, rightPercent] = [
    (leftValue - min) / (max - min) * 100,
    (rightValue - min) / (max - min) * 100
  ];
  if (leftPercent < 0 || leftPercent == void 0)
    leftPercent = 0;
  if (rightPercent > 100 || rightPercent == void 0)
    rightPercent = 100;
  return [leftPercent, rightPercent];
};




/***/ }),

/***/ 651337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ModalFooter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const ModalFooter = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 693701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DotOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DotOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M3 15C4.65685 15 6 13.6569 6 12C6 10.3431 4.65685 9 3 9C1.34315 9 0 10.3431 0 12C0 13.6569 1.34315 15 3 15Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 605078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PriceFilter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(603626);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(853675);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285212);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(917709);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PriceFilter = (_a) => {
  var _b = _a, {
    value,
    step = 1,
    onFilter,
    max,
    min
  } = _b, props = __objRest(_b, [
    "value",
    "step",
    "onFilter",
    "max",
    "min"
  ]);
  const margin = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const newMargin = __spreadValues({}, value);
    if ((value == null ? void 0 : value.lte) === void 0 || (value == null ? void 0 : value.lte) >= max) {
      newMargin.lte = max;
    }
    if ((value == null ? void 0 : value.gte) === void 0 || (value == null ? void 0 : value.gte) <= min) {
      newMargin.gte = min;
    }
    return newMargin;
  }, [max, min, JSON.stringify(value)]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputNumberGroups, {
    justify: "space-between",
    marginBottom: "s4"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: margin.gte
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: margin.lte
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .InputSlider */ .s, {
    range: true,
    size: isMobile ? _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xl */ .mO.xl : _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs,
    min,
    max,
    step,
    value: [margin.gte, margin.lte],
    onChange: ([gte, lte]) => {
      const value2 = {
        lte: Math.min(lte, max),
        gte: Math.max(gte, min)
      };
      onFilter == null ? void 0 : onFilter(value2.gte, value2.lte);
    },
    changeOn: "dragend"
  }));
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b)``;
const InputNumberGroups = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(({ theme }) => `
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 0px;
    border-top: 1px solid ${theme.colors.divider};
    top:50%;
    z-index: 0;
  }
`);
const StyledCurrency = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Currency */ .F)(({ theme }) => `
  width: 75px;
  padding: 0.25rem;
  border: 1px solid ${theme.colors.divider};
  font-size: 0.7rem;
  border-radius: ${theme.borderRadius.s};
  background-color: ${theme.colors.white};
  z-index: 0;
  text-align: center;
`);




/***/ }),

/***/ 36123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Grid; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, () => `
display: flex;
flex-wrap: wrap;
`);
const Grid = (_a) => {
  var _b = _a, {
    colNum = 2,
    children,
    itemWidth
  } = _b, props = __objRest(_b, [
    "colNum",
    "children",
    "itemWidth"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), Array.isArray(children) && children.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    key: index,
    style: {
      width: itemWidth ? itemWidth : `${100 / colNum}%`,
      flexShrink: 0
    }
  }, item)));
};




/***/ }),

/***/ 901113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ HamperGrid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(428247);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41796);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var modules_page_builder_slots_HamperCarousel_HamperCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25254);
/* harmony import */ var modules_product_detail_shared_ConfirmOver18YearOldModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(923540);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










const HamperGrid = (param)=>{
    let { products , productsPerRow =5 , regionName , type ="grid" , itemsPerPage , className , hamperItemKey  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { 0: showPopupCheckAge , 1: setShowPopupCheckAge  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const page = router.query.page ? Number(router.query.page) : 1;
    const handleSetShowPopupCheckAge = (value)=>{
        setShowPopupCheckAge(value);
        if (!value) {
            (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .markUserIsOver18 */ .P1)();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        isMobile: isMobile,
        className: className,
        children: [
            products === null || products === void 0 ? void 0 : products.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Grid, {
                    isMobile: isMobile,
                    productsPerRow: productsPerRow,
                    type: type,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_page_builder_slots_HamperCarousel_HamperCard__WEBPACK_IMPORTED_MODULE_5__/* .HamperCard */ .e, _objectSpreadProps(_objectSpread({}, item), {
                        hamperCardType: modules_page_builder_slots_HamperCarousel_HamperCard__WEBPACK_IMPORTED_MODULE_5__/* .EHamperCardType.HAMPER_ITEM */ .v.HAMPER_ITEM,
                        hamperItemKey: hamperItemKey,
                        tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingData */ .O5)({
                            isTrackContent: true,
                            regionName,
                            contentName: item.sku,
                            target: "productDetail",
                            index: itemsPerPage ? index + (page - 1) * itemsPerPage : index,
                            payload: item.bestComboDiscount && Number(item.bestComboDiscount) !== 0 ? JSON.stringify({
                                promotionType: "combo"
                            }) : undefined
                        }) : {},
                        type: type,
                        setShowPopupCheckAge: setShowPopupCheckAge
                    }))
                }, index)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_product_detail_shared_ConfirmOver18YearOldModal__WEBPACK_IMPORTED_MODULE_7__.ConfirmOver18YearOldModal, {
                showPopupCheckAge: showPopupCheckAge,
                setShowPopupCheckAge: handleSetShowPopupCheckAge,
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("T\xf4i tr\xean 18 tuổi"),
                onCancel: ()=>setShowPopupCheckAge(false)
            })
        ]
    });
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div((param)=>{
    let { isMobile  } = param;
    return '\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: 2px;\n    place-content: flex-start space-between;\n    padding: 2px 0;\n    &::after{\n      content: "";\n      flex: auto;\n    }\n    '.concat(isMobile ? "padding: 5px;" : "", "\n  ");
});
const Grid = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div((param)=>{
    let { productsPerRow , type , isMobile  } = param;
    return "\n  background: white;\n  margin-bottom: 2px;\n  ".concat(type === "grid" ? "width: calc(".concat(100 / productsPerRow, "% - 2px);") : "width: 100%;", "\n  ").concat(isMobile ? "border-radius: 8px;" : "", "\n  }");
});


/***/ }),

/***/ 344520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ BuildPCFilterMobile; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(811495);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(217622);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(465385);
/* harmony import */ var _teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(646807);
/* harmony import */ var _teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(327513);
/* harmony import */ var _teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(129892);
/* harmony import */ var _teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(362568);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(605078);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(580871);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46610);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(912841);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(36123);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _modules_search_page_shared_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(774608);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  top: 150px;\n  bottom: unset;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  -moz-transition: all 0.25s;\n  -ms-transition: all 0.25s;\n  -o-transition: all 0.25s;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s ease-in-out;\n  overflow: hidden;\n  max-height: '10rem';\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 5px;\n  margin: 0px 4px 8px 4px;\n  display: block;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  transition: 'all 0.25s ease-in-out';\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  width: 85%;\n  right: 0;\n  top: 0;\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n  border-top-right-radius: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  background: #fff;\n  padding: 0 16px;\n  position: sticky;\n  top: 40px;\n  z-index: 1040;\n  height: 40px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 12px 16px;\n  background: #fff;\n  text-align: center;\n  z-index: 1200;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  max-height: 100%;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  margin: auto;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  border-right: 0.5px solid #ddd;\n  height: 16px;\n  margin: 0 8px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}










const BuildPCFilterMobile = (param)=>{
    let { onClickLayout , layoutType , filters , loading =false , filterPrice , activeOptions , activeSortOption , onSortOptionSelected , onSubmit , onClearFilters  } = param;
    const { brand: theme  } = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .F)();
    const { 0: showFilter , 1: setShowFilter  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: showSort , 1: setShowSort  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { sortByCreatedAt  } = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { 0: priceFilter , 1: setPriceFilter  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(filterPrice.value);
    const { 0: filterActiveOptions , 1: setFilterActiveOptions  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(activeOptions);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilterActiveOptions(activeOptions);
    }, [
        activeOptions
    ]);
    const onClickFilterOption = (option)=>{
        const optionIndex = filterActiveOptions.findIndex((opt)=>opt.filterCode === option.filterCode && opt.filterId === option.filterId && opt.optionId === option.optionId);
        if (optionIndex > -1) {
            setFilterActiveOptions((prev)=>prev.filter((_, index)=>index !== optionIndex));
        } else {
            setFilterActiveOptions((prev)=>[
                    ...prev,
                    option
                ]);
        }
    };
    const isOptionSelected = (id, name)=>{
        return !!filterActiveOptions.find((option)=>option.optionId === id && option.optionName === name);
    };
    // render sort bar
    const renderSortBar = ()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SortBarBottomSheet, {
            zIndex: 1010,
            position: "top",
            show: showSort,
            closeBottomSheet: ()=>setShowSort(false),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                children: (0,_modules_search_page_shared_helpers__WEBPACK_IMPORTED_MODULE_5__/* .getDefaultSortOptions */ .Fb)(sortByCreatedAt).map((option, index)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_6__/* .ListItem */ .H, {
                                onClick: ()=>{
                                    onSortOptionSelected(option);
                                    setShowSort(false);
                                },
                                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                    color: (activeSortOption === null || activeSortOption === void 0 ? void 0 : activeSortOption.optionCode) === option.optionCode ? "primary" : "",
                                    fontSize: 13,
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)(option.optionName)
                                }),
                                right: (activeSortOption === null || activeSortOption === void 0 ? void 0 : activeSortOption.optionCode) === option.optionCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .SvgIcon */ .l, {
                                    color: "primary",
                                    name: "check",
                                    size: 10
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .Divider */ .i, {})
                        ]
                    }, index);
                })
            })
        });
    };
    // render filter options excluding price filter
    const renderFilterOptions = ()=>{
        const displayFilters = (0,_modules_search_page_shared_helpers__WEBPACK_IMPORTED_MODULE_5__/* .getDisplayFilter */ .Ou)(filters);
        if (!displayFilters.length) return null;
        return displayFilters.map((attribute, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterBlock, {
                attribute: attribute,
                isOptionSelected: isOptionSelected,
                onSelectOption: onClickFilterOption
            }, index));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledFlex, {
                align: "center",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k, {
                        onClick: ()=>setShowSort(!showSort),
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                fontSize: 13,
                                fontWeight: "500",
                                children: activeSortOption && (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)(activeSortOption.optionName) || (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sắp xếp")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .SvgIcon */ .l, {
                                marginLeft: "4px",
                                color: "#333",
                                size: 8,
                                name: "caret-down"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k, {
                        align: "center",
                        children: [
                            layoutType && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k, {
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .SvgIcon */ .l, {
                                        onClick: onClickLayout,
                                        name: layoutType === "grid" ? "grid" : "list-layout",
                                        color: "#333",
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DividerVertical, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k, {
                                onClick: ()=>setShowFilter(true),
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                        fontSize: 13,
                                        fontWeight: "500",
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Bộ lọc")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .SvgIcon */ .l, {
                                        marginLeft: "2px",
                                        color: filterActiveOptions.length || filterPrice.value.gte > filterPrice.min || filterPrice.value.lte < filterPrice.max ? theme.primary : "#333",
                                        size: 18,
                                        name: "filter"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            renderSortBar(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterBottomSheet, {
                contentHeight: "100%",
                position: "right",
                show: showFilter,
                closeBottomSheet: ()=>setShowFilter(false),
                zIndex: 1051,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FilterContent, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterOptions, {
                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLoadingFilter, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_12__/* .BlockHeader */ .t, {
                                        title: {
                                            fontSize: 14,
                                            fontWeight: "500"
                                        },
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Khoảng gi\xe1 (đ)")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__/* .PriceFilter */ .W, _objectSpreadProps(_objectSpread({}, filterPrice), {
                                        onFilter: (gte, lte)=>setPriceFilter({
                                                gte,
                                                lte
                                            }),
                                        paddingBottom: "s8",
                                        paddingLeft: "s40",
                                        paddingRight: "s40"
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .Divider */ .i, {}),
                                    renderFilterOptions()
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionBar, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k, {
                                width: "100%",
                                align: "center",
                                justify: "end",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_14__/* .Button */ .z, {
                                        onClick: ()=>{
                                            setFilterActiveOptions([]);
                                            onClearFilters();
                                            setShowFilter(false);
                                        },
                                        variant: "primary",
                                        outline: true,
                                        size: "sm",
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("X\xf3a bộ lọc")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_14__/* .Button */ .z, {
                                        onClick: ()=>{
                                            onSubmit(filterActiveOptions, priceFilter);
                                            setShowFilter(false);
                                        },
                                        marginLeft: "8px",
                                        size: "sm",
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("\xc1p dụng")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const FilterBlock = (param)=>{
    let { attribute , onSelectOption , isOptionSelected  } = param;
    const { 0: showAll , 1: setShowAll  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const options = attribute.options;
    const blockRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const blockWrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(()=>{
        if (blockRef.current && blockWrapperRef.current) {
            if (showAll) {
                blockWrapperRef.current.style.maxHeight = blockRef.current.clientHeight + "px";
            } else {
                blockWrapperRef.current.style.maxHeight = "10rem";
            }
        }
    }, [
        showAll
    ]);
    if (!(options === null || options === void 0 ? void 0 : options.length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_12__/* .BlockHeader */ .t, {
                title: {
                    fontSize: 14,
                    fontWeight: "500"
                },
                children: attribute.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyleBlockWrapper, {
                ref: blockWrapperRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: blockRef,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledGrid, {
                        paddingBottom: "6px",
                        paddingX: "12px",
                        colNum: 2,
                        children: options.map((value, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledOption, {
                                onClickOption: ()=>onSelectOption(value),
                                isActive: isOptionSelected(value.optionId, value.optionName),
                                stickySize: "sm",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                    textAlign: "center",
                                    color: isOptionSelected(value.optionId, value.optionName) ? "primary" : "#333",
                                    fontSize: 13,
                                    maxLines: 1,
                                    children: value.optionName
                                })
                            }, index))
                    })
                })
            }),
            options.length > 8 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k, {
                justify: "center",
                paddingBottom: "s4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce_mobile__WEBPACK_IMPORTED_MODULE_14__/* .Button */ .z, {
                    variant: "link",
                    onClick: ()=>setShowAll(!showAll),
                    children: !showAll ? (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Xem th\xeam") : "Ẩn bớt"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_10__/* .Divider */ .i, {})
        ]
    });
};
const SortBarBottomSheet = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_16__/* .BottomSheet */ .R)(_templateObject());
const StyleBlockWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject1());
const StyledOption = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_17__/* .SelectOption */ .$)(_templateObject2());
const StyledGrid = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_18__/* .Grid */ .r)(_templateObject3());
const FilterBottomSheet = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_16__/* .BottomSheet */ .R)(_templateObject4());
const StyledFlex = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k)(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.background;
});
const FilterContent = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b)(_templateObject6());
const ActionBar = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .k)(_templateObject7());
const FilterOptions = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b)(_templateObject8());
const StyledLoadingFilter = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_19__/* .LogoLoading */ .h)(_templateObject9());
const DividerVertical = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].span(_templateObject10());


/***/ }),

/***/ 566783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useBuildPcProducts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927890);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39486);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(534090);
/* harmony import */ var _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(232771);
/* harmony import */ var hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(725530);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(634655);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(788813);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(360339);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







const useBuildPcProducts = (params, onCloseModal, categoryName)=>{
    const { discoveryServiceV2 , discoveryHelper  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useServices */ .Su)();
    const { isDisplayUom , showNewProductGift  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { frames  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useFrame */ .x)();
    const { transformProductWhenUserUnder18  } = (0,hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_4__/* .useHandlerUnderEighteenYearOld */ .x)();
    const { addHardware  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useBuildPCV2 */ .s)();
    const cartV2 = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useCartV2 */ .T6)();
    const _ref = (0,_teko_discovery_v2__WEBPACK_IMPORTED_MODULE_7__/* .useDiscoverySearchV2 */ .t)(discoveryServiceV2, _objectSpreadProps(_objectSpread({}, params), {
        isNeedFeaturedProducts: false
    }), {
        transform: (data)=>{
            var ref;
            return {
                products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, {
                        showUom: isDisplayUom,
                        frames,
                        showNewProductGift,
                        cartV2
                    })),
                filter: data.filter,
                pagination: {
                    totalItems: data.total,
                    totalPages: Math.ceil(data.total / constants_index__WEBPACK_IMPORTED_MODULE_8__/* .BUILD_PC_MODAL_PAGE_SIZE */ .aJ)
                }
            };
        }
    }), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    const productList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return ((result === null || result === void 0 ? void 0 : result.products) || []).map((p)=>_objectSpreadProps(_objectSpread({}, p), {
                ctaButton: !p.contactButton ? _objectSpread({
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Chọn"),
                    variant: "secondary"
                }, (0,helpers__WEBPACK_IMPORTED_MODULE_10__/* .isServerless */ .ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        addHardware(categoryName, {
                            sku: p.sku,
                            quantity: 1
                        });
                        onCloseModal();
                    }
                } : {}) : undefined
            })).map(transformProductWhenUserUnder18);
    }, [
        JSON.stringify(result === null || result === void 0 ? void 0 : result.products),
        transformProductWhenUserUnder18,
        categoryName, 
    ]);
    return _objectSpread({
        products: productList,
        filter: result === null || result === void 0 ? void 0 : result.filter,
        pagination: result === null || result === void 0 ? void 0 : result.pagination
    }, rest);
};


/***/ }),

/***/ 774608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ getKeyFromNode; },
/* harmony export */   "Fb": function() { return /* binding */ getDefaultSortOptions; },
/* harmony export */   "I_": function() { return /* binding */ getCollectionSlug; },
/* harmony export */   "N2": function() { return /* binding */ findChildren; },
/* harmony export */   "N8": function() { return /* binding */ cookCategoryTree; },
/* harmony export */   "Ou": function() { return /* binding */ getDisplayFilter; },
/* harmony export */   "To": function() { return /* binding */ extractSortQuery; },
/* harmony export */   "j3": function() { return /* binding */ getActiveSortOption; },
/* harmony export */   "kr": function() { return /* binding */ cookFilterPrice; },
/* harmony export */   "pt": function() { return /* binding */ omitQuery; },
/* harmony export */   "qh": function() { return /* binding */ convertSubsections; },
/* harmony export */   "tF": function() { return /* binding */ getDataFromKey; },
/* harmony export */   "wi": function() { return /* binding */ findAncestors; },
/* harmony export */   "xP": function() { return /* binding */ getSignatureQueryParam; }
/* harmony export */ });
/* unused harmony exports clearFilterLink, replaceVariablesWithValues */
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19840);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927250);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(634655);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(189782);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/**
 *
 * @param  query
 * @returns
 * remove dynamic params from query
 * - ex: domain.vn/c/abc?slug=abc&page=2 -> domain.vn/c/abc?page=2
 */ const omitQuery = (query)=>{
    const omitKeys = [
        "slug",
        "categoryId",
        "sellerCategoryId",
        "brandId",
        "sellerId", 
    ];
    return (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__/* .omit */ .CE)(query, omitKeys);
};
const joinSortQuery = (param)=>{
    let { sort , order  } = param;
    return "".concat(sort).concat(SORT_QUERY_JOIN_CHAR).concat(order);
};
const SORT_QUERY_JOIN_CHAR = "&";
const getDefaultSortOptions = (sortByCreatedAt)=>{
    return [
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Khuyến m\xe3i tốt nhất"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_DISCOUNT_PERCENT",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Gi\xe1 tăng dần"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_PRICE",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.ASC */ .d.ASC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Gi\xe1 giảm dần"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_PRICE",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Sản phẩm mới nhất"),
            optionCode: joinSortQuery({
                sort: !!sortByCreatedAt ? "SORT_BY_CREATED_AT" : "SORT_BY_PUBLISH_AT",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Sản phẩm b\xe1n chạy nhất"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_TOP_SALE_QUANTITY_7_DAYS",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        }, 
    ];
};
const extractSortQuery = (joinedQuery)=>{
    return joinedQuery.split(SORT_QUERY_JOIN_CHAR);
};
const getActiveSortOption = (query, sortByCreatedAt, defaultSortOptionCode)=>{
    const defaultSortOption = defaultSortOptionCode ? getDefaultSortOptions(sortByCreatedAt).find((option)=>option.optionCode === (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)(defaultSortOptionCode)) || null : null;
    const sortOptionFromQuery = getDefaultSortOptions(sortByCreatedAt).find((opt)=>opt.optionCode === joinSortQuery({
            sort: query.sort,
            order: query.order
        }));
    return sortOptionFromQuery !== null && sortOptionFromQuery !== void 0 ? sortOptionFromQuery : defaultSortOption;
};
const clearFilterLink = (rootPath, query)=>{
    return rootPath === "/search" ? "/search?router=productListing".concat(query.query ? "&query=".concat(query.query) : "") : "".concat( true ? window.location.origin : 0).concat(rootPath);
};
const cookFilterPrice = function() {
    let lte = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10000000, gte = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    /**
   * default : gte: 0, lte: 10.000.000, step = 500.000, delta = lte - gte
   * lte: is rounded to 50k, 500K, 1M, 5M
   * step = (delta / 20) is rounded to 5k, 10k, 100K, 500K
   */ lte = lte === null || isNaN(lte) ? 10000000 : lte;
    gte = gte === null || isNaN(gte) ? 0 : gte;
    let priceLte = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .stringToInteger */ .C)(lte.toString()) || (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .stringToInteger */ .C)(gte.toString(), 0) + 500000;
    const priceGte = 0;
    if (priceLte < 200000) {
        priceLte = Math.ceil(priceLte / 50000) * 50000;
    }
    if (priceLte > 200000 && priceLte < 500000) {
        priceLte = 500000;
    }
    if (priceLte > 500000 && priceLte < 5000000) {
        priceLte = Math.ceil(priceLte / 1000000) * 1000000;
    }
    if (priceLte > 5000000) {
        priceLte = Math.ceil(priceLte / 5000000) * 5000000;
    }
    const delta = priceLte - priceGte;
    let step = 100000;
    if (delta < 200000) {
        step = Math.ceil(delta / 100000) * 5000;
    /**minStep : 5.000d , maxStep: 10.000 */ }
    if (delta > 200000 && delta <= 2000000) {
        step = Math.ceil(delta / 200000) * 10000;
    /**minStep : 20.000d , maxStep: 100.000 */ }
    if (delta > 2000000 && delta <= 10000000) {
        step = Math.ceil(delta / 2000000) * 100000;
    /**minStep : 100.000d , maxStep: 500.000 */ }
    if (delta > 10000000) {
        step = 500000;
    }
    // steps
    return {
        max: priceLte,
        min: priceGte,
        step: step
    };
};
const getDisplayFilter = (filters)=>{
    return filters.filter((filter)=>{
        var ref;
        return (filter === null || filter === void 0 ? void 0 : (ref = filter.options) === null || ref === void 0 ? void 0 : ref.length) && filter.options.length > 1;
    });
};
const getCollectionSlug = (slug)=>slug ? "/c/".concat(slug) : "";
const getSignatureQueryParam = (query)=>{
    let signatureFilterQueryParams = {};
    const { brandId , sellerId , providerId , sellerCategories , masterCategoryIds , categoryId , sellerCategoryId ,  } = query;
    // handle link like this: /search?router=productListing&sellerCategories=015
    if (sellerCategories) {
        signatureFilterQueryParams = {
            masterCategoryIds: sellerCategories
        };
    } else if (masterCategoryIds) {
        signatureFilterQueryParams = {
            masterCategoryIds: masterCategoryIds
        };
    } else if (providerId) {
        signatureFilterQueryParams = {
            providerIds: [
                providerId
            ]
        };
    } else if (sellerId) {
        signatureFilterQueryParams = {
            sellerIds: [
                sellerId
            ]
        };
    } else if (brandId) {
        signatureFilterQueryParams = {
            brands: typeof brandId === "string" ? [
                brandId
            ] : [
                ...brandId
            ]
        };
    } else if (categoryId) {
        signatureFilterQueryParams = {
            masterCategoryIds: [
                categoryId
            ]
        };
    } else if (sellerCategoryId) {
        signatureFilterQueryParams = {
            categories: [
                sellerCategoryId
            ]
        };
    }
    return signatureFilterQueryParams;
};
/**
 *
 * @param i a number
 * @returns return '01' if i = 1, return '11' if i = 11
 */ const padString = (i)=>i < 10 ? "0" + i : "" + i;
const CURRENT_MONTH_KEY = "%currentMonth%";
const CURRENT_YEAR_KEY = "%currentYear%";
const replaceVariablesWithValues = (date, metaTitle)=>{
    const mapMetaTitleVariables = {
        [CURRENT_MONTH_KEY]: padString(date.getMonth() + 1),
        [CURRENT_YEAR_KEY]: padString(date.getFullYear())
    };
    if (metaTitle) {
        const reg = new RegExp(Object.keys(mapMetaTitleVariables).join("|"), "g");
        return metaTitle.replace(reg, (matched)=>mapMetaTitleVariables[matched]);
    }
    return metaTitle;
};
const cookCategoryTree = (rawCategories)=>{
    if (!(rawCategories === null || rawCategories === void 0 ? void 0 : rawCategories.length)) return {
        cookedCategories: {},
        cookedCategoriesById: new Map(),
        cookedCategoriesByCode: new Map()
    };
    const nodeMap = new Map();
    for (const c of rawCategories){
        nodeMap.set(c.id, _objectSpreadProps(_objectSpread({}, c), {
            children: {}
        }));
    }
    const result = {};
    const nodeById = new Map();
    const nodeByCode = new Map();
    for (const node of nodeMap.values()){
        var _parentId;
        const parentId = (_parentId = node.parentId) !== null && _parentId !== void 0 ? _parentId : 0;
        const parent = parentId ? nodeMap.get(parentId) : undefined;
        if (!parent) {
            result[node.id] = node;
        } else {
            parent.children[node.id] = node;
        }
        nodeById.set(node.id, node);
        nodeByCode.set(node.code, node);
    }
    return {
        cookedCategories: result,
        cookedCategoriesById: nodeById,
        cookedCategoriesByCode: nodeByCode
    };
};
const getKeyFromNode = (node)=>{
    var _parentId;
    return "".concat(node.id, "_").concat((_parentId = node.parentId) !== null && _parentId !== void 0 ? _parentId : 0);
};
const getDataFromKey = (key)=>{
    const [id, parentId] = key.split("_");
    return {
        id: Number(id),
        parentId: Number(parentId)
    };
};
const findChildren = function(node) {
    let skipInitial = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const keys = [];
    !skipInitial && (node === null || node === void 0 ? void 0 : node.id) && keys.push(getKeyFromNode(node));
    var _children;
    for (const child of Object.values((_children = node.children) !== null && _children !== void 0 ? _children : {})){
        keys.push(...findChildren(child));
    }
    return keys;
};
const findAncestors = function(node, cookedCategoriesById) {
    let skipInitial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const ancestorsKeys = [];
    !skipInitial && (node === null || node === void 0 ? void 0 : node.id) && ancestorsKeys.push(getKeyFromNode(node));
    let parentId = node === null || node === void 0 ? void 0 : node.parentId;
    while(parentId){
        const parent = cookedCategoriesById.get(parentId);
        if (!parent) break;
        ancestorsKeys.push(getKeyFromNode(parent));
        parentId = parent.parentId;
    }
    return ancestorsKeys;
};
const convertSubsections = (subsectionsFromWorkload)=>{
    const { brands , others  } = subsectionsFromWorkload;
    const res = [];
    if (!!brands && !!brands.length) {
        res.push({
            type: "IMAGES",
            items: brands.map((brand)=>({
                    linkUrl: brand.url,
                    thumbnailUrl: brand.logo
                }))
        });
    }
    others === null || others === void 0 ? void 0 : others.forEach((other)=>{
        if (!!(other === null || other === void 0 ? void 0 : other.items.length)) {
            res.push({
                type: "IMAGES_AND_TEXT",
                title: other.label,
                items: other.items.map((item)=>({
                        linkUrl: item.url,
                        thumbnailUrl: item.image,
                        description: item.description
                    }))
            });
        }
    });
    return res;
};


/***/ })

}]);